<template>
  <div ref="target">
    <transition name="fade-up" appear>
      <div v-if="intersecting">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useIntersectionObserver } from '@vueuse/core'

export default {
  name: 'LazySection',
  setup() {
    const target = ref(null)
    const intersecting = ref(false)

    const { stop } = useIntersectionObserver(
      target,
      ([{ isIntersecting }]) => {
        if (isIntersecting) {
          intersecting.value = true
          stop()
        }
      },
      {
        rootMargin: '0px 0px -20% 0px',
      }
    )

    return {
      target,
      intersecting,
    }
  },
}
</script>

<style>
.fade-up-enter-active,
.fade-up-leave-active {
  transition: all 0.8s ease-in-out;
}
.fade-up-enter-from,
.fade-up-leave-to {
  opacity: 0;
  transform: translateY(80px);
}
</style>
